import {
  faDownload,
  faEye,
  faPen,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";

import Download_offcanvas from "../../../../../../../common/common_offcanvas/download_offcanvas/Download_offcanvas";
import Delete_offcanvas from "../../../../../../../common/common_offcanvas/delete_offcanvas/Delete_offcanvas";
import ScopeOfTheLaboratory_view_offcanvas from "../scopeOfTheLaboratory_view_offcanvas/ScopeOfTheLaboratory_view_offcanvas";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import {
  Create,
  GetAll,
  Delete,
} from "../../../../../../../../src/features/admin/quality_management/structural_requirement/scope_of_laboratoy/Slice";
import { useDispatch } from "react-redux";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";
import { useSelector } from "react-redux";
import ScopeOfTheLaboratory_Edit_Offcanvas from "../ScopeOfTheLaboratory_Edit_Offcanvas/ScopeOfTheLaboratory_Edit_Offcanvas";

function ScopeOfTheLaboratory_table({ data, setCurrentPage, currentPage ,fetchCustomers}) {
  const dispatch = useDispatch();
  const [view, setView] = useState(false);
  const [viewId, setViewId] = useState(null);
  const [showEdit, setEdit] = useState(false);
  const [showEditId, setEditId] = useState(null);
  const [showDownload, setDownload] = useState(false);
  const [showDelete, setDelete] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [selectedDownloadId, setSelectedDownloadId] = useState(null);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveViewPermission = permissions?.includes(
    FixIDS.scope_of_laboratory.View,
  );
  const haveEditPermission = permissions?.includes(
    FixIDS.scope_of_laboratory.Edit,
  );
  const haveDeletePermission = permissions?.includes(
    FixIDS.scope_of_laboratory.Delete,
  );

  /* ================= DELETE HANDLER ================= */
  const handleDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await dispatch(Delete(selectedDeleteId)).unwrap(); // call redux thunk
      await dispatch(GetAll()); // refresh the table
      // setDelete(false); // close offcanvas
      setSelectedDeleteId(null); // reset
    } catch (err) {
      console.error("Delete failed", err);
      alert("Delete failed");
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDownloadConfirm = async () => {
    if (!selectedDownloadId) return;

    const row = data?.data?.find((item) => item.id === selectedDownloadId);

    if (!row || !row.Scope_Of_Laboratory_Documents?.length) {
      alert("File not found");
      return;
    }

    const files = row.Scope_Of_Laboratory_Documents.map(
      (doc) => `${process.env.REACT_APP_IMG_URL}${doc.document_path}`,
    );

    for (const file of files) {
      await handleDownload(file);
    }
  };

  const handleDownload = async (imagePath) => {
    try {
      const response = await fetch(imagePath);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = imagePath.split("/").pop();

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download failed", err);
    }
  };

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Date</th>
                  <th>Discipline / Group</th>
                  <th>Material Or Products Tested</th>
                  <th>
                    Component, Parameter Or Characteristic Tested / Specific
                    Test Performed / Tests Or Type Of Tests Performed
                  </th>
                  <th>
                    Test Method Specification against which tests are performed
                    & / or the techniques / equipment used
                  </th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {Array.isArray(data?.data) &&
                  data.data.map((row, index) => (
                    <tr key={index}>
                      <td>
                        {(data?.current_page - 1) * data?.per_page + index + 1}
                      </td>
                      <td>{formatDate(row?.createdAt)}</td>
                      <td>{row?.discipline}</td>
                      <td>{row?.Material_Tested?.name}</td>
                      <td>{row?.Component?.name}</td>
                      <td>{row?.Test_Method?.name}</td>

                      <td>
                        <div className="action_icons">
                          {/* VIEW → always visible */}

                          {haveViewPermission && (
                            <FontAwesomeIcon
                              icon={faEye}
                              onClick={() => {
                                setView(true);
                                setViewId(row.id);
                              }}
                            />
                          )}

                          {/* DOWNLOAD + DELETE → only if documents exist */}
                          {row?.Scope_Of_Laboratory_Documents?.length > 0 && (
                            <>
                              {/* <FontAwesomeIcon
                                icon={faDownload}
                                onClick={() => {
                                  setSelectedDownloadId(row.id);
                                  setDownload(true);
                                }}
                              /> */}

                              {haveEditPermission && (
                                <FontAwesomeIcon
                                  icon={faPen}
                                  onClick={() => {
                                    setEdit(true);
                                    setEditId(row.id);
                                  }}
                                />
                              )}

                              {haveDeletePermission && (
                                <FontAwesomeIcon
                                  icon={faTrashCan}
                                  onClick={() => {
                                    setSelectedDeleteId(row.id);
                                    setDelete(true);
                                  }}
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="comon_page_footer">
          <div className="show_entry_div">
            <p className="show_text">
              Showing {(data?.current_page - 1) * data?.per_page + 1} To{" "}
              {Math.min(data?.current_page * data?.per_page, data?.total)} Of{" "}
              {data?.total} Entries
            </p>
          </div>

          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={data?.current_page}
              totalPages={data?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* ================= VIEW ================= */}
      <ScopeOfTheLaboratory_view_offcanvas
        show={view}
        handleClose={() => setView(false)}
        id={viewId}
      />

      {/* ================= DOWNLOAD ================= */}
      <Download_offcanvas
        show={showDownload}
        handleClose={() => setDownload(false)}
        offcanvasHeading="Download Scope Of The Laboratory"
        massageText={"Scope Of The Laboratory"}
        onConfirm={handleDownloadConfirm}
      />

      {/* Edit */}
      {haveEditPermission && (
        <ScopeOfTheLaboratory_Edit_Offcanvas
        fetchCustomers={fetchCustomers}
          show={showEdit}
          handleClose={() => setEdit(false)}
          id={showEditId}
        />
      )}

      {/* ================= DELETE ================= */}
      <Delete_offcanvas
        show={showDelete}
        handleClose={() => setDelete(false)}
        handleDelete={handleDelete}
        offcanvasHeading="Delete Scope Of The Laboratory"
        massageText={"Scope Of The Laboratory"}
      />
    </>
  );
}

export default ScopeOfTheLaboratory_table;
